import axios from "axios";
import { url } from "../config";

const checkPass = async (id, pass) => {
  const responsive = await axios.get(`${url}/check/${id}/${pass}`);
  const { data } = responsive;
  return data;
};

export { checkPass };
